export default __webpack_public_path__ + "static/media/Code1.966f2d40.svg";